<template>
  <v-container fluid>
    <form v-on:submit.prevent="doSearch">
      <v-row align="center" justify="center">
        <v-col cols="12" md="8" lg="6" xl="5">
          <v-text-field
            v-model="$store.state.projects.search"
            clearable
            hide-details
            solo
            x-large
            label="Search"
            prepend-inner-icon="fa-search"
            @click:clear="clearSearch"
          ></v-text-field>
        </v-col>
      </v-row>
    </form>
  </v-container>
</template>
<script>
export default {
  name: "",
  methods: {
    scrollToProjects() {
      this.$vuetify.goTo("#projects", {
        duration: 300,
        offset: 100,
        easing: "easeInOutCubic"
      });
    },
    clearSearch() {
      this.$store.state.projects.search = "";
      this.doSearch();
    },
    async doSearch() {
      console.log("doSearch");
      await this.$store.dispatch("projects/search");
      //this.scrollToProjects();
    }
  },
  computed: {
    halfwayOffset() {
      return 50;
    }
  },
  data: () => ({
    search: ""
  })
};
</script>
<style lang="scss" scoped>
</style>
